import { noop, type Unsubscribe } from '@amazon/vinyl-util'
import { getDeviceConfig } from '@/device/deviceConfig'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('initializeOnScreenKeyboard')

/**
 * Binds the app's D-pad keyboard on a device whose platform shows none for web
 * content (`onScreenKeyboard: 'app'`). The binding (`./bindOnScreenKeyboard`)
 * and the keyboard are lazy chunks, so other devices never download them.
 */
export function initializeOnScreenKeyboard(): Unsubscribe {
    const { keyMap, onScreenKeyboard } = getDeviceConfig()
    if (onScreenKeyboard !== 'app') return noop

    let disposed = false
    let teardown: Unsubscribe | undefined

    import('./bindOnScreenKeyboard')
        .then(({ bindOnScreenKeyboard }) => {
            if (!disposed) teardown = bindOnScreenKeyboard(keyMap)
        })
        .catch(errorHandler)

    return () => {
        disposed = true
        teardown?.()
        teardown = undefined
    }
}
